"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_1 = __importDefault(require("react"));
const FormFieldFromProps_1 = __importDefault(require("@Fields/v2/FormFieldFromProps"));
const IdentifiersSection = (props) => {
    const { hfaPublisherNumber, ipiNumber, isni, rightsHolderData } = props;
    return (react_1.default.createElement("section", { className: 'identifiers-section' },
        react_1.default.createElement("h5", null, "Identifiers"),
        react_1.default.createElement("div", { className: 'fields-row-container' },
            react_1.default.createElement(FormFieldFromProps_1.default, { field: hfaPublisherNumber, isDisabled: !!hfaPublisherNumber }),
            react_1.default.createElement("span", { className: "line" },
                react_1.default.createElement(FormFieldFromProps_1.default, { field: ipiNumber, isDisabled: !!rightsHolderData.ipiNumber }),
                react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'Once an IPI number has been communicated to The MLC, it cannot be updated. If you need to make a change,' +
                        ' please contact support.' })),
            react_1.default.createElement(FormFieldFromProps_1.default, { field: isni }))));
};
exports.default = IdentifiersSection;
